import React, { useEffect, useState } from "react";
import "./HomeCollectionCss/Profileform.css";
import manImg from "../../Assets/man.png";
import homeImg from "../../Assets/website png.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import VerificationProfile from "./VerificationProfile";
import { getOtp, getProfileStatus, validateOtp } from "../../api/api";
import CustomLoader from "../../common/loader/CustomLoader";
import { useNavigate } from "react-router-dom";
import OtpValidate from "./OtpValidate";
import toast from "react-hot-toast";
import {
  convertToMMDDYYYY,
  formatDate,
  parseDateChange,
  showFieldError,
} from "../../utils/helper";
import { getUserData, getUserMobile } from "../../utils/auth";
import useValidateForm from "../../Hooks/useValidateForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { defaultFormData } from "../../utils/defaultFormData";

// const validationSchema = Yup.object({
//   mobile_no: Yup.string()
//     .required("Mobile number is required")
//     .matches(/^[0-9]{10}$/, "Must be 10 digits"),
//   PFirstName: Yup.string().required("First name is required"),
//   PLastName: Yup.string().required("Last name is required"),
//   email: Yup.string().email("Invalid email"),
//   dateofbirth: Yup.string().required("Date of birth is required"),
// });

export const ProfileForm = ({
  formData,
  setFormData,
  onNext,
  setFormValid,
  patientType,
  setPatientType,
  setIsOtpverified,
  isOtpVerified,
  selectedPatient,
  setSelectedPatient,
  setShowOtp,
  showOtp,
  setShowVerification,
  showVerification,
  showPatientType,
  setShowPatientType,
  profileData,
  setProfileData,
  handleChange,
  allFieldsTouched,
  setAllFieldsTouched,
}) => {
  //   const [showVerification, setShowVerification] = useState(true);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const isLoggedin = Boolean(getUserData());
  const mobileData = getUserMobile();
  const [visibleErrors, setVisibleErrors] = useState({});
  const [validationErrorList, setValidationErrorList] = useState("");
  // Map of fieldName -> errorMessage produced by Yup validation
  // const [fieldErrors, setFieldErrors] = useState({});
  // Track which fields were touched (for inputs that don't use Formik)
  const [touchedFields, setTouchedFields] = useState({});

  const profileSchema = Yup.object({
    mobile_no: Yup.string()
      .required("Mobile number is required")
      .matches(
        /^[0-9]{10}$/,
        "Please enter 10 digits"
      ),
    PFirstName: Yup.string()
      .required("First name is required")
      .matches(/^[a-zA-Z\s]+$/, "Special characters not allowed"),
    PLastName: Yup.string()
      .required("Last name is required")
      .matches(/^[a-zA-Z\s]+$/, "Special characters not allowed"),
    dateofbirth: Yup.string().required("Date of birth is required"),
    PSex: Yup.string().required("Gender is required"),
    email: Yup.string().email("Invalid email format").nullable().notRequired(),
  });

  const { isValid, fieldErrors } = useValidateForm(formData, profileSchema);
  useEffect(() => {
    setFormValid(isValid);
  }, [isValid]);

  useEffect(() => {
    if (
      !isOtpVerified &&
      formData.mobile_no.length === 10 &&
      profileData.length === 0
    ) {
      handleCheckProfile();
    }
  }, []);

  useEffect(() => {
    if (!isOtpVerified && (formData.mobile_no || "").toString().length === 10) {
      console.log("Mobile number is valid:", formData.mobile_no);
      handleCheckProfile();
    }
  }, [formData.mobile_no, isOtpVerified]);

  const handleCheckProfile = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      mobile_no: formData?.mobile_no.toString(),
    };
    try {
      setLoading(true);
      const res = await getProfileStatus(payload);
      console.log("Profile Status Response:", res);
      setProfileData(res?.data?.data);
      setShowVerification(true);
    } catch (error) {
      console.error("Error checking profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    navigate("/users/login");
  };

  const handleOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: formData?.mobile_no.toString(),
      };
      const res = await getOtp(payload);
      console.log("OTP Response:", res);
      toast.success("OTP sent successfully.");
      setShowVerification(false);
      setShowOtp(true);
    } catch (error) {
      console.error("Error generating OTP:", error);
      toast.error("Failed to generate OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitVerify = async (otp) => {
    console.log("Verifying OTP:", otp);

    try {
      if (otp.length < 4) {
        toast.error("Please enter a valid 4-digit OTP.");
        return;
      }

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: formData?.mobile_no.toString(),
        OTP: otp,
        Reg_status: "1",
      };

      const res = await validateOtp(payload);
      console.log("OTP Verification Response:", res);
      if (res?.data?.status === "success") {
        toast.success("OTP verified successfully.");
        setIsOtpverified(true);
        setShowOtp(false);
        setShowVerification(false);
        setShowPatientType(true);
      } else {
        toast.error("OTP verification failed. Please try again.");
      }
    } catch (error) {
      toast.error("OTP verification failed. Please try again.");
    }
  };

  const handlePatientChange = (e) => {
    const userId = e.target.value;
    setSelectedPatient(userId);

    const selectedProfile = profileData.find(
      (profile) => profile.user_id.toString() === userId
    );

    if (selectedProfile) {
      const altMobile = selectedProfile.Alt_mobile_no;
      // Update Formik values directly
      // formik.setValues({
      //   ...formik.values,
      //   user_id: selectedProfile.user_id || "",
      //   mobile_no: selectedProfile.mobile_no || "",
      //   PFirstName: selectedProfile.PFirstName || "",
      //   PLastName: selectedProfile.PLastName || "",
      //   email: selectedProfile.email || "",
      //   dateofbirth: formatDate(selectedProfile.dateofbirth) || "",
      //   PSex:
      //     selectedProfile.PSex === "M"
      //       ? "M"
      //       : selectedProfile.PSex === "F"
      //       ? "F"
      //       : "M",
      //   address: selectedProfile.address || "",
      //   landmark: selectedProfile.landmark || "",
      //   Zipcode: selectedProfile.Zipcode || "",
      //   City: selectedProfile.City || "",
      //   State: selectedProfile.State || "",
      //   altPhone: selectedProfile.altPhone || "",
      // });

      // Sync with parent formData state as well
      setFormData((prev) => ({
        ...prev,
        user_id: selectedProfile.user_id || "",
        mobile_no: selectedProfile.mobile_no || "",
        PFirstName: selectedProfile.PFirstName || "",
        PLastName: selectedProfile.PLastName || "",
        email: selectedProfile.email || "",
        // dateofbirth: formatDate(selectedProfile.dateofbirth) || "",
        dateofbirth: parseDateChange(selectedProfile.dateofbirth),

        PSex:
          selectedProfile.PSex === "M"
            ? "M"
            : selectedProfile.PSex === "F"
            ? "F"
            : "M",
        address: selectedProfile.address || "",
        landmark: selectedProfile.landmark || "",
        Zipcode: selectedProfile.Zipcode || "",
        City: selectedProfile.City || "",
        State: selectedProfile.State || "",
        Alt_mobile_no:
        altMobile && altMobile.toString().length === 10
          ? altMobile
          : "",
      }));
      // re-validate after populating values
      // formik.validateForm().then(() => {
      //   setFormValid(!!formik.isValid);
      // });
    }
  };

  function handleSpecialChar(e) {
  const value = e.target.value;

  if (/^[a-zA-Z\s]*$/.test(value)) {
    handleChange(e);
  }
}

  function handleOnlyNumber(e) {
    const value = e.target.value;
    // Only allow numbers
    if (/^[0-9]*$/.test(value)) {
      handleChange(e);
    }
  }

  return (
    <>
      {loading && <CustomLoader />}
      <div className="profile-form-main">
        {/* LEFT: FORM */}
        <div className="profile-form-container">
          <h2 className="form-heading">Patient Basic Information</h2>

          {/* Row 1 */}
          <div className="profile-form-row">
            <div className="profile-form-group mb-3">
              {/* <label>
                Mobile Number<span>*</span>
              </label> */}
              <input
                type="tel"
                name="mobile_no"
                disabled={isLoggedin || isOtpVerified}
                value={isLoggedin ? mobileData : formData.mobile_no}
                onChange={(e) => {
                  handleOnlyNumber(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    mobile_no: true,
                  }));
                }}
                onPaste={(e) => e.preventDefault()}
                placeholder="Mobile Number*"
                autoComplete="off"
                maxLength={10}
                onFocus={(e) => {
                  if (!isOtpVerified && formData?.mobile_no?.length === 10) {
                    handleCheckProfile();
                  }
                }}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "mobile_no")) && (
                <span className="error-text">{fieldErrors.mobile_no}</span>
              )}
            </div>

            {showPatientType && (
              <div className="profile-form-group">
                <label>
                  Select Patient Type<span>*</span>
                </label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="patientType"
                      value="existing"
                      checked={patientType === "existing"}
                      onChange={() => setPatientType("existing")}
                      onBlur={(e) =>
                        setTouchedFields((prev) => ({
                          ...prev,
                          [e.target.name]: true,
                        }))
                      }
                    />{" "}
                    Existing
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="patientType"
                      value="new"
                      checked={patientType === "new"}
                      onChange={() => {
                        setPatientType("new");
                        setSelectedPatient("");
                        setFormData({
                          ...defaultFormData,
                          mobile_no: formData.mobile_no,
                        });
                      }}
                      onBlur={(e) =>
                        setTouchedFields((prev) => ({
                          ...prev,
                          [e.target.name]: true,
                        }))
                      }
                    />{" "}
                    New
                  </label>
                </div>
              </div>
            )}

            {patientType === "existing" && profileData.length > 0 && (
              // <div className="profile-form-group wide-select">
              <div className="profile-form-group wide-select">
                {/* <label>
                  Select Patient<span>*</span>
                </label> */}
                <select value={selectedPatient} onChange={handlePatientChange}>
                  <option value="">-- Select Patient Name --</option>
                  {profileData.map((profile) => (
                    <option key={profile.user_id} value={profile.user_id}>
                      {`${profile.PFirstName} ${profile.PLastName}`}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Row 2 */}
          <div className="profile-form-row">
            <div className="profile-form-group mb-3">
              {/* <label>
                First Name<span>*</span>
              </label> */}
              <input
                type="text"
                name="PFirstName"
                placeholder="First Name*"
                value={formData.PFirstName}
                onChange={(e) => {
                  handleSpecialChar(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PFirstName")) && (
                <span className="error-text">{fieldErrors.PFirstName}</span>
              )}
            </div>

            <div className="profile-form-group mb-3">
              {/* <label>
                Last Name<span>*</span>
              </label> */}
              <input
                type="text"
                name="PLastName"
                placeholder="Last Name*"
                value={formData.PLastName}
                onChange={(e) => {
                  handleSpecialChar(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PLastName")) && (
                <span className="error-text">{fieldErrors.PLastName}</span>
              )}
            </div>
          </div>

          {/* Row 3 */}
          <div className="profile-form-row">
            <div className="profile-form-group mb-3">
              <DatePicker
                selected={formData.dateofbirth}
                onChange={(date) =>
                  setFormData((prev) => ({ ...prev, dateofbirth: date }))
                }
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Date of Birth*"
                className="custom-date-input"
                readOnly={patientType === "existing"}
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "dateofbirth")) && (
                <span className="error-text">{fieldErrors.dateofbirth}</span>
              )}
            </div>
            <div className="profile-form-group mb-3">
              <label>
                Gender<span>*</span>
              </label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="PSex"
                    value="M"
                    checked={formData.PSex === "M"}
                    onChange={handleChange}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="PSex"
                    value="F"
                    checked={formData.PSex === "F"}
                    onChange={handleChange}
                    onBlur={(e) =>
                      setTouchedFields((prev) => ({
                        ...prev,
                        [e.target.name]: true,
                      }))
                    }
                  />{" "}
                  Female
                </label>
              </div>
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "PSex")) && (
                <span className="error-text">{fieldErrors.PSex}</span>
              )}
            </div>

            {/* <div className="profile-form-group">
             
              <DatePicker
                selected={formData.dateofbirth}
                onChange={(date) =>
                  setFormData((prev) => ({ ...prev, dateofbirth: date }))
                }
                showMonthDropdown
                showYearDropdown
                dropdownMode="select" 
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Date of Birth*"
                className="custom-date-input"
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "dateofbirth")) && (
                <span className="error-text">{fieldErrors.dateofbirth}</span>
              )}
            </div> */}
          </div>

          {/* Row 4 */}
          <div className="profile-form-row">
            <div className="profile-form-group mb-3">
              <input
                type="email"
                name="email"
                placeholder="Email(optional)"
                value={formData.email}
                onChange={(e) => {
                  handleChange(e);
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }}
                autoComplete="off"
                onBlur={(e) =>
                  setTouchedFields((prev) => ({
                    ...prev,
                    [e.target.name]: true,
                  }))
                }
              />
              {(allFieldsTouched ||
                showFieldError(touchedFields, fieldErrors, "email")) && (
                <span className="error-text">{fieldErrors.email}</span>
              )}
            </div>

            <div className="profile-form-group mb-3">
              <input
                type="text"
                name="altPhone"
                maxLength={10}
                placeholder="Alternative Number (optional)"
                value={formData.altPhone}
                onChange={handleOnlyNumber}
                autoComplete="off"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>
        </div>

        {/* RIGHT: PHOTO */}
        <div className="profile-photo-section">
          <img
            src={homeImg}
            alt="Profile"
            className="attached-profile-photo"
            style={{ height: "270px", width: "100%", maxWidth: "300px" }}
          />
        </div>
        {/* <div className="profile-photo-section">
          <img src={manImg} alt="Profile" className="attached-profile-photo" />
        </div> */}

        {!isLoggedin && showVerification && profileData?.length > 0 && (
          <VerificationProfile
            onClose={() => {
              setShowVerification(false);
              setFormData((prev) => ({
                ...prev,
                mobile_no: "",
              }));
            }}
            onOtp={handleOtp}
            onLogin={handleLogin}
          />
        )}

        {showOtp && (
          <OtpValidate
            onClose={() => { setShowOtp(false)
               setFormData((prev) => ({
                ...prev,
                mobile_no: "",
              }));
            }}
            
            onVerify={handleSubmitVerify}
            mobile={formData?.mobile_no}
            onResend={handleOtp}
            // onResend={handleResend}
          />
        )}
      </div>
    </>
  );
};
